import React, { useState, useEffect, useRef } from 'react';
import { Checkbox, Col, DatePicker, Form, Input, Modal, Row, Select } from 'antd';
import './style.scss';
import ButtonVplus from 'pages/VinaphonePlusNew/components/ButtonVplus/ButtonVplus';
import { arrow_left, book_person_icon, close_icon, coupon_icon, crown_icon, info_circle_icon, location_icon, present_icon, register_vplus, vplus_logo } from 'assets/imgs/VinaphonePlus';
import { VPlusService } from 'services/VPlusService';
import Swiper from 'react-id-swiper';
import OTPVplus from 'pages/VinaphonePlusNew/components/OTPVplus/OTPVplus';
import { v4 as uuidv4 } from 'uuid';
import { CommonService } from 'services/CommonService';
import { Notification } from 'components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useDispatch } from 'react-redux';
import { LIST_VNPP_TITLE_LOGOUT } from 'pages/Header/Header';
import { UserService } from 'services/UserService';
import { doGetUserInfoVplus, doGetUserPromoMenu, doLogout, doLogoutVplus, doTokenDevVplus, doTokenHoiVienEscVplus, doTokenHoiVienVplus } from 'store/action/userAction';
import moment from 'moment';
import {LoyaltyService} from "../../../../services/LoyaltyService";

const ModalVPlusRegister = ({
  onSubmit = () => {},
  onCancel = () => {},
  isOpen = false,
  customerInfo
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const uuid = useRef(uuidv4()).current;
  const [formRegister] = Form.useForm();
  const [isTerm, setIsTerm] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [district, setDistrict] = useState([]);
  const [ward, setWard] = useState([]);
  const [provinceId, setProvinceId] = useState(null);
  const [districtId, setDistrictId] = useState(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isModalOTP, setIsModalOTP] = useState(false);
  const [isOtpError, setIsOtpError] = useState(false);
  const [isRegisterSuccess, setIsRegisterSuccess] = useState(false);
  const [dataCookie, setDataCookie] = useState();
  const [titleErrorRegister, setTitleErrorRegister] = useState();
  const [messageErrorRegister, setMessageErrorRegister] = useState();
  const [isModalErrorRegister, setIsModalErrorRegister] = useState(false);
  const selectRefs = {
    provinceSelect: useRef(null),
    districtSelect: useRef(null),
    wardSelect: useRef(null),
    gender: useRef(null),
  };
  const isLoyalty = localStorage?.getItem("flowType") === "Loyalty";
  const [requestRegisterMember, setRequestRegisterMember] = useState();

  const swiperRef = useRef(null);

  const paramsSwiper = {
    slidesPerView: 1,
    allowTouchMove: false,
  };

  const personalFields = [
    {
      key: isLoyalty ? 'fullName' : 'tenHoiVien',
      label: 'Họ tên',
      colSpan: 24,
      rules: [{ required: true, message: 'Vui lòng Nhập tên họ tên' }],
      render: () => <Input placeholder="Nhập họ tên" maxLength={200} />
    },
    {
      key: isLoyalty ? 'dateOfBirth' : 'ngaySinh',
      label: 'Ngày sinh',
      colSpan: 12,
      rules: [{ required: true, message: 'Vui lòng Nhập ngày sinh' }],
      render: () => <DatePicker suffixIcon={null} format="DD/MM/YYYY" placeholder="Nhập ngày sinh" />
    },
    {
      key: isLoyalty ? 'gender' : 'gioiTinh',
      label: 'Giới tính',
      colSpan: 12,
      rules: [{ required: true, message: 'Vui lòng Chọn giới tính' }],
      render: () => (
        <Select
          ref={selectRefs.gender}
          placeholder="Chọn giới tính"
          options={[
            { value: 0, label: 'Nam' },
            { value: 1, label: 'Nữ' },
            // { value: 2, label: 'Khác' },
          ]}
          dropdownRender={(menu) => (
            <div className="custom-dropdown-select-register">
              {menu}
            </div>
          )}
          onDropdownVisibleChange={(visible) => {
            if (!visible) {
              setTimeout(() => {
                if (selectRefs.gender.current) {
                  selectRefs.gender.current.blur();
                }
              }, 100);
            }
          }}
        />
      )
    },
    {
      key: isLoyalty ? 'identifierType' : 'giayToDinhDanhId',
      label: 'Loại giấy tờ định danh',
      colSpan: 12,
      rules: [{ required: true, message: 'Vui lòng Chọn Loại giấy tờ định danh' }],
      render: () => (
        <Select
          placeholder="Chọn Loại giấy tờ định danh"
          options={isLoyalty ? [
            {value: 'CCCD', label: 'CCCD'}
          ] : [
            {value: 2, label: 'CCCD'},
          ]}
          disabled
        />
      )
    },
    {
      key: isLoyalty ? 'identifier' : 'soGiayToDinhDanh',
      label: 'Số giấy tờ định danh',
      colSpan: 12,
      rules: [
        { required: true, message: 'Vui lòng Nhập số CCCD' },
        { pattern: /^\d{1,13}$/, message: 'Chỉ được nhập tối đa 13 chữ số' }
      ],
      render: () => (
        <Input
          placeholder="Nhập số CCCD"
          maxLength={13}
        />
      )
    },
  ];

  const contactFields = [
    {
      key: isLoyalty ? 'soDienThoai' :'soDienThoai',
      label: 'Điện thoại',
      colSpan: 12,
      rules: [
        { required: true, message: 'Nhập số điện thoại liên hệ' },
        {
          validator: (_, value) => {
            if (!value || value.trim() === '') {
              return Promise.reject();
            }
            const regex = /^(0\d{9}|84\d{9})$/;
            if (!regex.test(value)) {
              return Promise.reject(new Error('Số điện thoại không đúng định dạng.'));
            }
            return Promise.resolve();
          },
        },
      ],
      normalize: (value) => value?.replace(/\D/g, ''),
      render: () => (
        <Input
          placeholder="Nhập số điện thoại"
          maxLength={11}
          minLength={10}
          readOnly
        />
      ),
    },
    {
      key: isLoyalty ? 'email' : 'email',
      label: 'Email liên hệ',
      colSpan: 12,
      rules: [
        { required: true, message: 'Vui lòng nhập địa chỉ email' },
        {
          validator: (_, value) => {
            if (!value) {
              return Promise.reject();
            }
            const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;
            if (!emailRegex.test(value)) {
              return Promise.reject(new Error("Email không đúng định dạng"));
            }
            if (value.length > 256) {
              return Promise.reject(new Error("Địa chỉ email không được vượt quá 256 ký tự"));
            }
            return Promise.resolve();
          },
        },
      ],
      render: () => (
        <Input type="email" placeholder="Nhập email" maxLength={256} />
      ),
    },
  ];

  const addressFields = [
    {
      key: isLoyalty ? 'provinceId' : 'tinhId',
      label: 'Tỉnh/Thành phố',
      colSpan: 24,
      rules: [
        { required: true, message: 'Vui lòng Chọn Tỉnh/Thành phố' }
      ],
      render: () => (
        <Select
          ref={selectRefs.provinceSelect}
          placeholder="Chọn tên Tỉnh/Thành phố"
          notFoundContent={<div className="not-found-txt">Không tìm thấy địa chỉ phù hợp</div>}
          showSearch
          options={provinces}
          filterOption={(input, option) =>
            (removeVietnameseTones(option?.label) ?? '').toLowerCase().includes(removeVietnameseTones(input).toLowerCase())
          }
          dropdownRender={(menu) => (
            <div className="custom-dropdown-select-register">
              {menu}
            </div>
          )}
          onChange={(value) => handleProvinceChange(value)}
          onDropdownVisibleChange={(visible) => {
            if (!visible) {
              setTimeout(() => {
                if (selectRefs.provinceSelect.current) {
                  selectRefs.provinceSelect.current.blur();
                }
              }, 100);
            }
          }}
        />
      ),
    },
    {
      key: isLoyalty ? 'districtId' : 'quanId',
      label: 'Quận/Huyện',
      colSpan: 24,
      rules: [
        { required: true, message: 'Vui lòng Chọn Quận/Huyện' }
      ],
      render: () => (
        <Select
          ref={selectRefs.districtSelect}
          placeholder="Chọn tên Quận/Huyện"
          notFoundContent={<div className="not-found-txt">Không tìm thấy địa chỉ phù hợp</div>}
          showSearch
          options={district}
          filterOption={(input, option) =>
            (removeVietnameseTones(option?.label) ?? '').toLowerCase().includes(removeVietnameseTones(input).toLowerCase())
          }
          dropdownRender={(menu) => (
            <div className="custom-dropdown-select-register">
              {menu}
            </div>
          )}
          onChange={(value) => handleDistrictChange(value)}
          onDropdownVisibleChange={(visible) => {
            if (!visible) {
              setTimeout(() => {
                if (selectRefs.districtSelect.current) {
                  selectRefs.districtSelect.current.blur();
                }
              }, 100);
            }
          }}
        />
      ),
    },
    {
      key: isLoyalty ? 'wardId' : 'phuongId',
      label: 'Phường/Xã',
      colSpan: 24,
      rules: [
        { required: true, message: 'Vui lòng Chọn Phường/Xã' }
      ],
      render: () => (
        <Select
          ref={selectRefs.wardSelect}
          placeholder="Chọn tên Phường/Xã"
          notFoundContent={<div className="not-found-txt">Không tìm thấy địa chỉ phù hợp</div>}
          showSearch
          options={ward}
          filterOption={(input, option) =>
            (removeVietnameseTones(option?.label) ?? '').toLowerCase().includes(removeVietnameseTones(input).toLowerCase())
          }
          dropdownRender={(menu) => (
            <div className="custom-dropdown-select-register">
              {menu}
            </div>
          )}
          onDropdownVisibleChange={(visible) => {
            if (!visible) {
              setTimeout(() => {
                if (selectRefs.wardSelect.current) {
                  selectRefs.wardSelect.current.blur();
                }
              }, 100);
            }
          }}
        />
      ),
    },
    {
      key: isLoyalty ? 'address' : 'diaChi',
      label: 'Địa chỉ',
      colSpan: 24,
      rules: [
        { required: true, message: 'Vui lòng Nhập địa chỉ cụ thể' }
      ],
      render: () => (
        <Input
          placeholder="Nhập số nhà, đường"
          maxLength={200}
        />
      ),
    },
  ];

  useEffect(() => {
    if (isOpen) {
      clearForm();

      if (!isLoyalty) {
        formRegister.setFieldsValue({soDienThoai: CommonService.convert84to0(localStorage.getItem('mobile'))});
      }
    }
    if (!provinces[0] && isOpen) {
      if (localStorage?.getItem("flowType") === "Loyalty") {
        getLocationAddressLoyalty({locationType: 1, locationCode: 0});
      } else if (localStorage?.getItem("flowType") === "Vplus") {
        getDmDiaBan({
          Type: 0,
          DiaBanId: 0
        })
      }
    }
  }, [isOpen]);

  useEffect(() => {
    if (provinceId) {
      if (localStorage?.getItem("flowType") === "Loyalty") {
        getLocationAddressLoyalty({locationType: 2, locationCode: provinceId});
      } else if (localStorage?.getItem("flowType") === "Vplus") {
        getDmDiaBan({Type: 1, DiaBanId: provinceId});
      }

      setDistrictId(null);
      formRegister.setFieldsValue(isLoyalty ? {districtId: null, wardId: null} : {quanId: null, phuongId: null});
      setWard([]);
    }
  }, [provinceId]);

  useEffect(() => {
    if (districtId) {
      if (localStorage?.getItem("flowType") === "Loyalty") {
        getLocationAddressLoyalty({locationType: 3, locationCode: districtId});
      } else if (localStorage?.getItem("flowType") === "Vplus") {
        getDmDiaBan({Type: 2, DiaBanId: districtId});
      }
      formRegister.setFieldsValue(isLoyalty ? {wardId: null} : {phuongId: null});
    }
  }, [districtId]);
  
  const removeVietnameseTones = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const getDmDiaBan = async (payload) => {
    try {
      let request = {
        ...payload,
        byPass: "1"
      }
      await VPlusService.getDmDiaBan(request, res => {
        if (res?.errorCode === "0") {
          if (payload.Type === 0) {
            setProvinces(groupByAlphabet(res?.result?.data));
          } else if (payload.Type === 1) {
            setDistrict(groupByAlphabet(res?.result?.data));
          } else if (payload.Type === 2) {
            setWard(groupByAlphabet(res?.result?.data));
          }
        }
      })
    } catch (error) {
      console.log(error);
    }
  };

  const getLocationAddressLoyalty = async (payload) => {
    try {
      await LoyaltyService?.locationCatalog(payload, null, res => {
        if (res && res?.errorCode === "0" && res?.result) {
          if (payload?.locationType === 1) {
            setProvinces(groupByAlphabetLoyalty(res?.result));
          } else if (payload?.locationType === 2) {
            setDistrict(groupByAlphabetLoyalty(res?.result));
          } else if (payload?.locationType === 3) {
            setWard(groupByAlphabetLoyalty(res?.result));
          }
        }
      })
    } catch (error) {
      console.log("getLocationAddressLoyalty: ", error);
    }
  };

  const groupByAlphabet = (array) => {
    const grouped = array.reduce((acc, item) => {
      const firstLetter = item.name.charAt(0).toUpperCase();
      if (!acc[firstLetter]) {
        acc[firstLetter] = [];
      }
      acc[firstLetter].push(item);
      return acc;
    }, {});
    const sortedGroups = Object.keys(grouped).sort().map(letter => ({
      label: letter,
      options: grouped[letter].sort((a, b) => a.name.localeCompare(b.name)).map(e => ({label: e.name, value: e.id})),
    }));
    return sortedGroups;
  };

  const groupByAlphabetLoyalty = (array) => {
    const grouped = array.reduce((acc, item) => {
      const firstLetter = item.name.charAt(0).toUpperCase();
      if (!acc[firstLetter]) {
        acc[firstLetter] = [];
      }
      acc[firstLetter].push(item);
      return acc;
    }, {});
    const sortedGroups = Object.keys(grouped).sort().map(letter => ({
      label: letter,
      options: grouped[letter].sort((a, b) => a.name.localeCompare(b.name)).map(e => ({
        label: e?.name,
        value: e?.code
      })),
    }));
    return sortedGroups;
  };

  const handleProvinceChange = (value) => {
    setProvinceId(value)
    formRegister.setFieldsValue({ district: null, ward: null });
  }

  const handleDistrictChange = (value) => {
    setDistrictId(value)
    formRegister.setFieldsValue({ ward: null });
  }

  const handleConfirmRegisterMembership = () => {
    const allFields = [...personalFields, ...contactFields, ...addressFields];
    const isMissingInformation = allFields.some(field => customerInfo?.[field.key] === null)
    
    if(isMissingInformation) {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.slideNext();
      }
    } else {
      handleRegisterMembership()
    }
  }

  const handleCloseVplusRegister = () => {
    onCancel();
    // clearForm();
    formRegister.resetFields();
    if (window.location.pathname.includes('/vinaphone-plus')) {
      window.location.assign('/');
    }
  }

  const clearForm = () => {
    setProvinceId(null);
    setDistrictId(null);
    setDistrict([])
    setWard([])
    setIsTerm(false);
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(0, 0);
    }
    formRegister.resetFields();
  }

  const handleFormChange = async  () => {
    const hasErrors = formRegister.getFieldsError().some(({ errors }) => errors.length > 0);
    const fieldValues = formRegister.getFieldsValue();
    const hasEmptyRequiredFields = Object.values(fieldValues).some(
      (value) => value === undefined || value === '' || value === null
    );
    setIsSubmitDisabled(hasErrors || hasEmptyRequiredFields);
  };

  const handleRegisterMembership = () => {
    formRegister.validateFields().then(values => {
      if (localStorage?.getItem("flowType") === "Loyalty") {
        setRequestRegisterMember({...customerInfo, ...values});
        handleSendOtpLoyalty({...customerInfo, ...values});

      } else if (localStorage?.getItem("flowType") === "Vplus") {
        const payload = {
          ...values,
          ngaySinh: values?.ngaySinh ? values?.ngaySinh?.format("DD/MM/YYYY") : null,
          diaChiThuongTru: values?.diaChi,
        }
        handleSendOtp(payload);
      }
    }).catch(err => {
      console.log(err);
    })
  }

  const handleSendOtpLoyalty = async (payload) => {
    try {
      const dataHandle = {
        ...payload,
        otpId: "",
        otpValue: "",
        requestId: uuid
      }
      apiRegisterMember(dataHandle);
    } catch (error) {
      Notification.error('Lỗi hệ thống khi gửi OTP. Vui lòng thử lại sau.');
    }
  };

  const handleVerifyOTPLoyalty = async (otp) => {
    const payload = {
      ...requestRegisterMember,
      otpId: dataCookie,
      otpValue: otp,
      requestId: uuid
    }
    await apiRegisterMember(payload);
  };

  const handleSendOtp = async (payload) => {
    try {
      const dataHandle = {
        ...payload,
        otpValue: null,
        customerId: customerInfo?.customerId,
        maMayUuid: uuid + "_WEB",
        heDieuHanh: "WEB",
      }
      apiRegisterMemberInfo(dataHandle);
    } catch (error) {
      Notification.error('Lỗi hệ thống khi gửi OTP. Vui lòng thử lại sau.');
    }
  };

  const handleVerifyOTP = async (otp) => {
    const payload = {
      otpValue: otp,
      customerId: customerInfo?.customerId,
      maMayUuid: uuid + "_WEB",
      heDieuHanh: "WEB",
      cookie: dataCookie
    }
    await apiVerifyMemberInfo(payload);
  }

  const handleResendOTP = async () => {
    handleRegisterMembership();
  }

  const handleCancelModalOTP = () => {
    setIsModalOTP(false);
    setIsOtpError(false);
  }

  const apiRegisterMember = async (payload) => {
    try {
      LoyaltyService.registerMember(payload, (res) => {
        // if (res?.errorCode == 0) {
        switch (res?.errorCode) {
          case "0":
            // Đăng ký hội viên thành công
            handleSetMessageErrorRegister(
                "Đăng ký thành công",
                "Chúc mừng bạn đã đăng ký thành công Hội viên VinaPhone Plus.",
                true
            );
            handleCancelModalOTP();
            break;

          case "100":
            setDataCookie(res?.data);
            Notification.success(res?.message);
            onCancel();
            setIsModalOTP(true);
            break;

          case "101":
            Notification.error(res?.message);
            break;
          case "106":
            Notification.error(res?.message);
            break;

          case "wrong_otp":
          case "101":
          case "102":
          case "103":
          case "104":
          case "105":
          case "106":
            // sai OTP || OTP đã được gửi quá số lần quy định. Vui lòng thử lại sau. || .....
            Notification.error(res?.message);
            setIsOtpError(true);
            break;

          case "23":
          case "29":
          case "04":
            handleSetMessageErrorRegister(
                "Chưa thể đăng ký hội viên",
                `Để được hỗ trợ đăng ký, bạn vui lòng liên hệ Tổng đài 1800 1091 nhé.<br/>Mã hỗ trợ ${res?.errorCode}`
            );
            onCancel();
            break;
            // case "-3":
            //   formRegister.setFields([{
            //     name: "soDienThoai",
            //     errors: ["Nhập số điện thoại để tiếp tục"],
            //   },]);
            //   break;
            // case "-5":
            //   formRegister.setFields([{
            //     name: "soDienThoai",
            //     errors: ["Số điện thoại không đúng định dạng"],
            //   },]);
            //   break;
            // case "-6":
            //   formRegister.setFields([{
            //     name: "email",
            //     errors: ["Email không đúng định dạng"],
            //   },]);
            //   break;
            // case "-9":
            //   handleSetMessageErrorRegister(
            //       "Chưa thể đăng ký hội viên",
            //       "Bạn đã huỷ hội viên 3 lần trong 12 tháng vừa qua. Để đăng ký lại, bạn vui lòng liên hệ Tổng đài 1800 1091 để được hỗ trợ."
            //   );
            //   onCancel();
            //   break;
            // case "-10":
            //   let cancelDate;
            //   const message = res?.result?.Message;
            //   const regex = /\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}/g;
            //   const matches = message.match(regex);
            //
            //   if (matches && matches.length > 0) {
            //     cancelDate = moment(matches[matches.length - 1], "DD/MM/YYYY HH:mm:ss").format("HH:mm DD/MM/YYYY");
            //   }
            //   handleSetMessageErrorRegister(
            //       "Chưa thể đăng ký hội viên",
            //       `Bạn đã huỷ hội viên vào lúc ${cancelDate}. Vui lòng quay lại sau 48 giờ kể từ thời điểm đó để đăng ký lại nhé.`
            //   );
            //   onCancel();
            //   break;
            // case "-12":
            //   formRegister.setFields([{
            //     name: "soDienThoai",
            //     errors: ["Số điện thoại đã tồn tại"],
            //   },]);
            //   break;
            // case "-13":
            //   formRegister.setFields([{
            //     name: "email",
            //     errors: ["Email đã tồn tại"],
            //   },]);
            //   break;
          default:
            handleSetMessageErrorRegister(
                "Chưa thể đăng ký hội viên",
                `Để được hỗ trợ đăng ký, bạn vui lòng liên hệ Tổng đài 1800 1091 nhé.<br/>Mã hỗ trợ: ${res?.errorCode}`
            );
            onCancel();
            break;
        }
        // } else {
        //   Notification.error(res?.message);
        //   onCancel();
        // }
        // onCancel();
        // clearForm();
      });
    } catch (error) {
      Notification.error('Lỗi hệ thống. Chúng tôi đã ghi nhận và sẽ khắc phục sớm.');
    }
  };

  const apiRegisterMemberInfo = async (payload) => {
    try {
      VPlusService.apiRegisterMember(payload, (res) => {
        if (res?.errorCode == 0) {
          switch (res?.result?.Error) {
            case 0:
              setDataCookie(res?.data);
              Notification.success(res?.result?.Message);
              onCancel(); 
              setIsModalOTP(true);
              break;
            case -3:
              formRegister.setFields([{
                name: "soDienThoai",
                errors: ["Nhập số điện thoại để tiếp tục"],
              },]);
              break;
            case -5:
              formRegister.setFields([{
                name: "soDienThoai",
                errors: ["Số điện thoại không đúng định dạng"],
              },]);
              break;
            case -6:
              formRegister.setFields([{
                name: "email",
                errors: ["Email không đúng định dạng"],
              },]);
              break;
            case -9:
              handleSetMessageErrorRegister(
                "Chưa thể đăng ký hội viên",
                "Bạn đã huỷ hội viên 3 lần trong 12 tháng vừa qua. Để đăng ký lại, bạn vui lòng liên hệ Tổng đài 1800 1091 để được hỗ trợ."
              );
              onCancel();
              break;
            case -10:
              let cancelDate;
              const message = res?.result?.Message;
              const regex = /\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}/g;
              const matches = message.match(regex);

              if (matches && matches.length > 0) {
                cancelDate = moment(matches[matches.length - 1], "DD/MM/YYYY HH:mm:ss").format("HH:mm DD/MM/YYYY");
              }
              handleSetMessageErrorRegister(
                "Chưa thể đăng ký hội viên",
                `Bạn đã huỷ hội viên vào lúc ${cancelDate}. Vui lòng quay lại sau 48 giờ kể từ thời điểm đó để đăng ký lại nhé.`
              );
              onCancel();
              break;
            case -12:
              formRegister.setFields([{
                name: "soDienThoai",
                errors: ["Số điện thoại đã tồn tại"],
              },]);
              break;
            case -13:
              formRegister.setFields([{
                name: "email",
                errors: ["Email đã tồn tại"],
              },]);
              break;
            default:
              handleSetMessageErrorRegister(
                "Chưa thể đăng ký hội viên",
                `Để được hỗ trợ đăng ký, bạn vui lòng liên hệ Tổng đài 1800 1091 nhé.<br/>Mã hỗ trợ: ${Math.abs(res?.result?.Error)}`
              );
              onCancel();
              break;
          }
        } else {
          Notification.error(res?.message);
          onCancel();
        }
        // onCancel();
        // clearForm();
      });
    } catch (error) {
      Notification.error('Lỗi hệ thống. Chúng tôi đã ghi nhận và sẽ khắc phục sớm.');
    }
  };

  const apiVerifyMemberInfo = async (payload) => {
    try {
      VPlusService.apiVerifyMemberInfo(payload, res => {
        if (res?.errorCode == 0) {
          switch (res?.result?.Error) {
            case 0:
              // Đăng ký hội viên thành công
              handleSetMessageErrorRegister(
                "Đăng ký thành công",
                "Chúc mừng bạn đã đăng ký thành công Hội viên VinaPhone Plus.",
                true
              );
              handleCancelModalOTP();
              break;
            case -2:
              // sai OTP 5 lần
              handleSetMessageErrorRegister(
                "Chưa thể đăng ký hội viên",
                "Bạn đã nhập sai OTP quá 5 lượt cho phép. Vui lòng thực hiện đăng ký lại."
              );
              handleCancelModalOTP();
              break;
            case -3:
              // sai OTP
              Notification.error("Mã xác thực OTP không đúng");
              setIsOtpError(true);
              break;
            case -4:
              // hết hạn OTP
              Notification.error("Mã xác nhận đã hết hạn");
              setIsOtpError(true);
              break;
            default:
              handleSetMessageErrorRegister(
                "Chưa thể đăng ký hội viên",
                `Để được hỗ trợ đăng ký, bạn vui lòng liên hệ Tổng đài 1800 1091 nhé.<br/>Mã hỗ trợ: ${Math.abs(res?.result?.Error)}`
              );
              handleCancelModalOTP();
              break;
          }
        } else {
          Notification.error(res?.message);
          handleCancelModalOTP();
        }
      });
    } catch (error) {
      Notification.error('Lỗi hệ thống. Chúng tôi đã ghi nhận và sẽ khắc phục sớm.');
    }
  };

  const handleSetMessageErrorRegister = (title, message, isSuccess = false) => {
    setTitleErrorRegister(title);
    setMessageErrorRegister(message);
    setIsModalErrorRegister(true);
    setIsRegisterSuccess(isSuccess);
  }

  const handleCloseModalErrorRegister = () => {
    setIsModalErrorRegister(false);
    setTitleErrorRegister(null);
    setMessageErrorRegister(null);
    if(isRegisterSuccess) {
      handleLogOut();
    } else {
      history.push('/');
    }
  }

  const handleLogOut = () => {
    const data = {
      msisdn: localStorage.getItem('mobile'),
    };

    UserService.logout(data, res => {
      if (res.error_code === '0') {
        dispatch(doLogout());
        dispatch(doLogoutVplus());
        localStorage.clear();
        dispatch(doTokenDevVplus(""));
        dispatch(doTokenHoiVienEscVplus(""));
        dispatch(doTokenHoiVienVplus(""));
        dispatch(doGetUserInfoVplus(undefined));
        dispatch(doGetUserPromoMenu(LIST_VNPP_TITLE_LOGOUT));
        history.push('/');
      } else {
        Notification.error("Có lỗi xảy ra!");
      }
    }, () => {
      Notification.error("Có lỗi xảy ra!");
    });
  }

  const navigatorTerm = () => {
    onCancel();
    history.push('/vinaphone-plus/about');
  }

  return (
    <>
      <Modal
        className="modal-vplus-membership-register"
        title={null}
        open={isOpen}
        closable={null}
        maskClosable={false}
        footer={null}
        width={576}
      >
        <div className="membership-register-carousel">
          <Swiper ref={swiperRef} {...paramsSwiper}>
            <div>
              <div className="membership-register-wapper" style={{background: `url(${register_vplus}) center / cover no-repeat`}}>
                <div className="membership-register-header">
                  <div className="membership-register-header-left"></div>
                  <div className="membership-register-header-middle"></div>
                  <div className="membership-register-header-right cursor-pointer" onClick={handleCloseVplusRegister}>
                    <img src={close_icon} alt="" />
                  </div>
                </div>
                <div className="membership-register-welcome">
                  <div className="membership-register-welcome__logo">
                    <img src={vplus_logo} alt="" />
                  </div>
                  <div className="membership-register-welcome__content">
                    <div className="welcome-title">Chào mừng bạn đến với VinaPhone Plus</div>
                    <div className="welcome-body">
                      <div className="welcome-subtitle">Hãy trở thành hội viên để nhận những đặc quyền của riêng bạn</div>
                      <div className="welcome-info__item">
                        <img src={present_icon} alt="" />
                        <span>Nhận quà bằng hiện vật hoặc điểm thưởng</span>
                      </div>
                      <div className="welcome-info__item">
                        <img src={coupon_icon} alt="" />
                        <span>Đổi điểm lấy quà tặng, sản phẩm, dịch vụ</span>
                      </div>
                      <div className="welcome-info__item">
                        <img src={crown_icon} alt="" />
                        <span>Ưu đãi độc quyền của VNPT</span>
                      </div>
                    </div>
                  </div>
                  <div className="membership-register__footer">
                    <Checkbox checked={isTerm} className="membership-register-checkbox" onChange={(e) => setIsTerm(e.target.checked)}>
                      <div className="ml-8">Bằng việc nhấn "Xác nhận trở thành hội viên", quý khách đồng ý với <span className="about-vplus" onClick={navigatorTerm}>Điều khoản điều kiện</span> của VinaPhone Plus</div>
                    </Checkbox>
                    <ButtonVplus disabled={!isTerm} className="primary membership-register-btn" onClick={handleConfirmRegisterMembership}>Xác nhận trở thành hội viên</ButtonVplus>
                    <div className="membership-register-help">Cần hỗ trợ, vui lòng liên hệ Tổng đài <a href="tel:18001091">1800 1091</a></div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="membership-register-wapper">
                <div className="membership-register-header">
                  <div className="membership-register-header-left cursor-pointer" onClick={handlePrev}>
                    <img src={arrow_left} alt="" />
                  </div>
                  <div className="membership-register-header-middle">Đăng ký hội viên VinaPhone Plus</div>
                  <div className="membership-register-header-right cursor-pointer" onClick={handleCloseVplusRegister}>
                    <img src={close_icon} alt="" />
                  </div>
                </div>
                <div>
                  <Form
                    layout="vertical"
                    form={formRegister}
                    className="membership-register__form"
                    onFieldsChange={handleFormChange}
                    initialValues={isLoyalty ? {
                      gender: 1,
                      identifierType: "CCCD"
                    } : {
                      gioiTinh: 1,
                      giayToDinhDanhId: 2,
                      // soDienThoai: CommonService.convert84to0(localStorage.getItem('mobile')),
                    }
                    }
                  >
                    {!personalFields.every(field => {
                      if (field.key === 'identifierType') {
                        return customerInfo?.identifier === null;
                      }
                      if (field.key === 'giayToDinhDanhId') {
                        return customerInfo?.soGiayToDinhDanh === null;
                      }
                      return customerInfo?.[field.key] !== null
                    }) &&
                      <div className="membership-register__item">
                        <Row gutter={8}>
                          <Col>
                            <img src={book_person_icon} alt="book_person_icon" />
                          </Col>
                          <Col>
                            <div className="membership-register__item--title">Thông tin cá nhân</div>
                          </Col>
                        </Row>
                        <Row gutter={[30, 30]}>
                          {personalFields.map(({ key, label, colSpan, render, rules }) => {
                            if (key === 'identifierType') {
                              if (customerInfo?.identifier !== null) return null;
                            } else if (key === 'giayToDinhDanhId') {
                              if (customerInfo?.soGiayToDinhDanh !== null) return null;
                            } else {
                              if (customerInfo?.[key] !== null) return null;
                            }
                            return (
                              <Col key={key} xs={24} sm={24} md={colSpan || 12}>
                                <Form.Item name={key} label={label} rules={rules}>
                                  {render()}
                                </Form.Item>
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    }

                    {!contactFields.every(field => customerInfo?.[field.key] !== null) &&
                      <div className="membership-register__item">
                        <Row gutter={8}>
                          <Col>
                            <img src={info_circle_icon} alt="info_circle_icon" />
                          </Col>
                          <Col>
                            <div className="membership-register__item--title">Thông tin liên hệ</div>
                          </Col>
                        </Row>
                        <Row gutter={[30, 30]}>
                          {contactFields.map(({ key, label, colSpan, render, rules }) => {
                            if (customerInfo?.[key] !== null) return null;
                            return (
                              <Col key={key} xs={24} sm={24} md={colSpan || 12}>
                                <Form.Item name={key} label={label} rules={rules}>
                                  {render()}
                                </Form.Item>
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    }

                    {!addressFields.every(field => customerInfo?.[field.key] !== null) &&
                      <div className="membership-register__item">
                        <Row gutter={8}>
                          <Col>
                            <img src={location_icon} alt="location_icon" />
                          </Col>
                          <Col>
                            <div className="membership-register__item--title">Địa chỉ</div>
                          </Col>
                        </Row>
                        <Row gutter={[30, 30]}>
                          {addressFields.map(({ key, label, colSpan, render, rules }) => {
                            if (customerInfo?.[key] !== null) return null;
                            return (
                              <Col key={key} xs={24} sm={24} md={colSpan || 12}>
                                <Form.Item name={key} label={label} rules={rules}>
                                  {render()}
                                </Form.Item>
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    }

                    <div className="membership-register--btn">
                      <ButtonVplus disabled={isSubmitDisabled} className="primary" onClick={handleRegisterMembership}>Đăng ký hội viên</ButtonVplus>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </Swiper>
        </div>
      </Modal>

      <Modal
        title={titleErrorRegister}
        className="modal-vplus"
        open={isModalErrorRegister}
        onOk={false}
        footer={null}
        onCancel={handleCloseModalErrorRegister}
      >
        <div className="modal-membership-result">
          <div className="modal-membership-result-content">
            <div className="modal-membership-result-txt">
              <div dangerouslySetInnerHTML={{
                __html: messageErrorRegister
              }}></div>
            </div>
          </div>
          <ButtonVplus className="primary" onClick={handleCloseModalErrorRegister}>
            Tôi đã hiểu
          </ButtonVplus>
        </div>
      </Modal>

      <OTPVplus
        visible={isModalOTP}
        onVerify={isLoyalty ? handleVerifyOTPLoyalty : handleVerifyOTP}
        onResend={handleResendOTP}
        onCancel={() => setIsModalOTP(false)}
        phoneNumber={CommonService.convert84to0(localStorage.getItem('mobile'))}
        isResend={true}
        isOtpError={isOtpError}
        setIsOtpError={setIsOtpError}
        isCheckOffNet={true}
        timeLeft={180}
      />
    </>
  );
};

export default ModalVPlusRegister;
